export default __webpack_public_path__ + "static/media/caution.9b006a59.svg";